var pizza = [
    {
        "id": "19",
        "name": "Pizza Quataro Formaggi",
        "category": "pizza",
        "img": "https://i.imgur.com/hcNPGxR.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 6.99
    },
    {
        "id": "20",
        "name": "Pizza Napoltana Tonno",
        "category": "pizza",
        "img": "https://i.imgur.com/eZCJv41.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 7.99
    },
    {
        "id": "21",
        "name": "Pizza taglio Charle",
        "category": "pizza",
        "img": "https://i.imgur.com/NOHbpzT.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 6.99
    },
    {
        "id": "22",
        "name": "Pizza Diavola Hawaiian",
        "category": "pizza",
        "img": "https://i.imgur.com/E4kySE8.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 8.99
    },
    {
        "id": "23",
        "name": "Pizza Pesto Chicken",
        "category": "pizza",
        "img": "https://i.imgur.com/jxa94gA.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 6.99
    },
    {
        "id": "24",
        "name": "Pizza BBQ Amrikana",
        "category": "pizza",
        "img": "https://i.imgur.com/2Bs6I55.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 7.99
    },


]
export default pizza;